import React, { useState } from "react";
import { Link, withRouter } from "react-router-dom";
import ImageLoader from "../../ImageLoader";
import RatingStart from "../../RatingStar";
import { composeArrayForRatings } from "../../CommonMethods";

const PremiumBox = (props) => {
  return (
    <li
      onClick={(e) => {
        e.preventDefault();
        props.history.push(`${props.profile_url}`);
      }}
    >
      <span className="clsBadgeContent premiumBadge">Premium</span>
      <div className="top_content_block">
        <div className="logo">
          <Link to={props.profile_url}>
            <ImageLoader
              image={props.logo}
              fallbackImage={"/static/images/FC-Generic-Logo.webp"}
              width={120}
              height={70}
            />
          </Link>
        </div>
        <div className="starRating">
          <div className="starIcon">
            <RatingStart
              starCount={composeArrayForRatings(props?.rating?.aggregate_score)}
              inline={true}
              withoutO
            />
          </div>
          <div className="ratingTxt">{`${props?.rating?.aggregate_score} / 5.0`}</div>
        </div>
      </div>
      <div className="footer_content_block">
        <div className="txt_block">
          {props.reviews_count ? (
            <>
              <span className="count">{props.reviews_count}</span>
              <span className="txt">customer references</span>
            </>
          ) : null}
        </div>
        <div className="customerReferenceList">
          <ul>
            {props.testimonial_count ? (
              <li
                onClick={(e) => {
                  e.preventDefault();
                  props.history.push(`${props.profile_url}/testimonials`);
                }}
              >
                <span className="count">{props.testimonial_count}</span>
                <span className="txt">Testimonials</span>
              </li>
            ) : null}
            {props.casestudy_count ? (
              <li
                onClick={(e) => {
                  e.preventDefault();
                  props.history.push(`${props.profile_url}/case-studies`);
                }}
              >
                <span className="count">{props.casestudy_count}</span>
                <span className="txt">Case Studies</span>
              </li>
            ) : null}
            {props.video_count ? (
              <li
                onClick={(e) => {
                  e.preventDefault();
                  props.history.push(`${props.profile_url}/customer-videos`);
                }}
              >
                <span className="count">{props.video_count}</span>
                <span className="txt">Customer Videos</span>
              </li>
            ) : null}
          </ul>
        </div>
      </div>
    </li>
  );
};

export default withRouter(PremiumBox);
